/*
 * Div4MessageArea: This component renders the status messages while APIs or user interactions are in progress.
 */
import React from "react";
import { useStatusMessage } from "../../contexts/StatusMessageContext";

const Div4MessageArea = ({
  activeStep,
  onOk,
}) => {
  const { status } = useStatusMessage();

  return (
    <div className={`child-div ${activeStep === 4 ? "active-step" : ""}`}>
      <div className={`app-div-subtitle ${status.isError ? "app-error" : ""}`}>
        <div className="title-container">
          {status.title}
        </div>
      </div>

      <p
        className={`${status.isError ? "app-text app-error" : "app-text"}`}
        dangerouslySetInnerHTML={{ __html: status.message }}
      />
      {status.isOkButtonVisible && (
        <button className="app-button" onClick={onOk}>
          OK
        </button>
      )}
    </div>
  );
};

export default Div4MessageArea;
